module.exports = __webpack_public_path__ + "img/im-likes.267c7288.svg";